export default "__VITE_ASSET__573249f9__"